import React from 'react';
import { Stack } from '@mui/material';
import { ArrowBackIcon, DataGrid } from '@orijinworks/frontend-commons';
import { AuditHeader, DataGridWrapper, RoundIconButton } from './Audit.styles';
import { Grey100Typography, NavyMainTypography } from '../../Feeds.style';
import { useAuditHook } from './useAuditHook';
import { AuditToggleButton } from './AuditToggleButton';
import DeleteModal from '../../../../shared/components/DeleteModal/DeleteModal';
import { Link } from 'react-router-dom';
import { FeedDrawer } from '../../../../shared/components/feed-drawer';

const Audit = () => {
    const { columns,
        modalRef,
        data,
        pageSize,
        loading,
        selectedType,
        totalRecordsCount,
        onFilterChangeHandler,
        onTypeChangeHandler,
        handleSelectedChangeHandler,
        refreshContactsHandler,
        onPageChangeHandler,
        onPageSizeChangeHandler,
        onSortChangeHandler,
        onTogglaModalHandlerHandler,
        onContinueDeleteModalHandlerHandler,
        handleBackClick,
        getModalTitle,
        getModalDescription,
        getFeedDrawerProps,
    } = useAuditHook();
   
    return (
        <Stack
            height="100%"
            backgroundColor="white"
            direction="column" spacing={2}>
            <AuditHeader>
                <Stack
                    padding={"20px"}
                    direction="row" spacing={2} alignItems="center">
                    <RoundIconButton 
                    LinkComponent={Link}
                    onClick={handleBackClick}
                    variant="contained" color="primary">
                        <ArrowBackIcon />
                    </RoundIconButton>
                    <Stack>
                        <NavyMainTypography variant="h1">
                            Audit Log
                        </NavyMainTypography>
                    </Stack>
                </Stack>
            </AuditHeader>
            <DataGridWrapper>
                {columns.length > 0 && (
                    <DataGrid
                        columns={columns}
                        data={[...data]}
                        pageSize={pageSize}
                        pageSizeOptions={[5, 10, 25, 50]}
                        paginationMode={'server'}
                        isLoading={loading}
                        onSelectionChange={handleSelectedChangeHandler}
                        showClearSelectionButton={true}
                        serverSidePaginationProps={{
                            onPageChange: onPageChangeHandler,
                            onPageSizeChange: onPageSizeChangeHandler,
                            onSortChange: onSortChangeHandler,
                            onFilterChange: onFilterChangeHandler,
                            totalRecordsCount
                        }}
                        onRefreshHandler={refreshContactsHandler}
                        hasActionColumn={true}
                        headerStartComponent={<AuditToggleButton selectedType={selectedType} onTypeChange={onTypeChangeHandler} />}
                        tdStyles={{
                            createdAt: {
                                width: 100,
                            },
                            recipient: {
                                width: 250,
                            },
                            sender: {
                                width: 250,
                            },
                            isDeleted: {
                                width: 100,
                            },
                        }}
                    />
                )}
            </DataGridWrapper>
            <DeleteModal
                modalRef={modalRef}
                title={getModalTitle()}
                description={getModalDescription()}
                open={false}
                onClose={onTogglaModalHandlerHandler}
                onContinue={onContinueDeleteModalHandlerHandler}
            />
            <FeedDrawer {...getFeedDrawerProps()} />
        </Stack>
    );
};

export default Audit;
